/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import {
  Alert, Autocomplete, Box, Button, Divider, Grid, LinearProgress, MenuItem, Snackbar, TextField,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Elements from '../../../Elements';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { fetchClient } from '../../../../Utils/helpers';
import { createCourier, getCourierDetail, updateCourier } from '../../../../Redux/Models/courier';

export default function UpdateCourier({
  classes, newCourier, error, message, isLoading, selectedCourier: courier,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { courierId } = useParams();
  const photoRef = useRef(null);
  const idRef = useRef(null);
  const licenseRef = useRef(null);
  const [activeStep, setActiveStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [label, setLabel] = useState({
    gender: 'Choose gender',
    marital: 'Choose marital',
  });

  const [files, setFiles] = useState({
    photo: '',
    driver_license_document: '',
    id_document: '',
  });

  const [personalData, setPersonalData] = useState({
    front_name: '',
    back_name: '',
    gender: '',
    marital_status: '',
    phone_number: '',
    email: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postal_code: '',
    password: '',
  });
  const [documentData, setDocumentData] = useState({
    id_number: '',
    driver_license_number: '',
  });
  const [confirm, setConfirm] = useState(false);
  const [cancel, setCancel] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedState, setSelectedState] = useState();
  const [selectedCity, setSelectedCity] = useState('');
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [loadCountries, setLoadCountries] = useState(false);
  const [loadCities, setLoadCities] = useState(false);

  useEffect(() => {
    if (courierId) {
      dispatch(getCourierDetail(courierId));
    }
  }, [courierId]);

  useEffect(() => {
    if (courierId && courier.personal_data) {
      setPersonalData({
        ...courier.personal_data,
        front_name: courier.personal_data?.front_name,
        back_name: courier.personal_data?.back_name,
      });
      setDocumentData({
        id_number: courier.document_data?.id_card,
        driver_license_number: courier.document_data?.driver_license_number,
      });
      setFiles({
        photo: courier.personal_data?.profile_picture,
        driver_license_document: courier.document_data?.driver_license_document,
        id_document: courier.document_data?.id_document,
      });
    }
  }, [courier]);

  const handleOnFocus = (e) => {
    setLabel({
      ...label,
      [e.target.id]: '',
    });
  };

  const handleOnBlur = () => {
    setLabel({
      gender: 'Choose gender',
      marital: 'Choose marital',
    });
  };

  const handleChangeFiles = (name, url) => {
    setFiles({ ...files, [name]: url });
  };

  const handleChangePD = (e) => {
    setPersonalData({ ...personalData, [e.target.name]: e.target.value });
  };

  const handleChangeDD = (e) => {
    setDocumentData({ ...documentData, [e.target.name]: e.target.value });
  };

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getImage = (name, step) => {
    if (step === activeStep) return Images[`${name}Active2`];
    if (step > activeStep) return Images[name];
    return Images.Check2;
  };

  const photoTrigger = (ref) => {
    ref?.current?.click();
  };

  const handleChangePhoto = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const acceptedExt = ['png', 'jpg', 'jpeg', 'gif'];
      const fileExt = file.name.split('.').reverse()[0];

      if (!acceptedExt.includes(fileExt?.toLowerCase())) {
        setSnackbar({ message: 'Sorry, You only can upload image file', severity: 'error', open: true });
        return;
      }

      const fileSize = file.size;
      if (fileSize > (10000 * 1000)) {
        setSnackbar({ message: 'Sorry, maximum file size is 10MB', severity: 'error', open: true });
        return;
      }

      setSnackbar({ message: 'Uploading...', severity: 'info', open: true });
      const body = new FormData();
      body.append('file', file);

      fetchClient({
        method: 'POST',
        url: '/upload',
        data: body,
      }).then((res) => {
        handleChangeFiles(e.target.name, res.data.data.url);
        setSnackbar({ message: 'Successfully upload...', severity: 'success', open: true });
      }).catch((err) => {
        setSnackbar({ message: err.response.data.message, severity: 'error', open: true });
      });
    }
  };

  const getCountries = () => {
    setLoadCountries(true);
    axios.get('https://countriesnow.space/api/v0.1/countries/states')
      .then((res) => {
        if (!res.data.error) {
          setCountries(res.data.data);
        }
        setLoadCountries(false);
      });
  };

  useEffect(() => {
    if (selectedCountry?.name && selectedState?.name) {
      setLoadCities(true);
      const body = {
        country: selectedCountry.name,
        state: selectedState.name,
      };
      axios.post('https://countriesnow.space/api/v0.1/countries/state/cities', body)
        .then((res) => {
          if (!res.data.error) {
            setCities(res.data.data);
          }
          setLoadCities(false);
        });
    }
  }, [selectedCountry, selectedState]);

  useEffect(() => {
    getCountries();
  }, []);

  const wantToContinue = () => {
    let valid = false;
    switch (activeStep) {
      case 1: {
        const unfilled = Object.keys(personalData).filter((key) => !personalData[key] && key !== 'last_name');
        if (!unfilled.length && files.photo) valid = true;
      }
        break;
      case 2: {
        const unfilled = Object.keys(documentData).filter((key) => !documentData[key]);
        if (!unfilled.length && files.driver_license_document && files.id_document) valid = true;
      }
        break;
      default: valid = false;
    }

    if (valid) {
      setActiveStep(activeStep + 1);
    } else {
      setSnackbar({
        open: true,
        message: 'Please complete the form!',
        severity: 'error',
      });
    }
  };

  const saveCourier = () => {
    setSubmitted(true);
    const body = {
      personal_data: {
        ...personalData,
        photo: files.photo,
      },
      document_data: {
        ...documentData,
        id_document: files.id_document,
        driver_license_document: files.driver_license_document,
      },
    };
    if (courierId) {
      dispatch(updateCourier(body, courierId));
    } else {
      dispatch(createCourier(body));
    }
  };

  useEffect(() => {
    if (error && submitted) {
      setSnackbar({
        open: true,
        severity: 'error',
        message: `Something went wrong, ${message}`,
      });
    }

    if (newCourier && submitted) {
      navigate(`${ROUTES.couriers()}/all`, 'replace');
    }
  }, [submitted, error, newCourier]);

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <div>
          <strong>Courier</strong>
          {' '}
          /
          {' '}
          {courierId ? 'Update' : 'New'}
          {' '}
          courier
        </div>

        <div className="mt-4">

          {isLoading && <LinearProgress color="inherit" sx={{ mb: 2 }} />}

          <div className="flex align-items-center flex-center">
            <div className="center">
              <img src={getImage('RequestIn', 1)} alt="Personal data" />
              <div className={`mt-1 s-14 ${activeStep === 1 && 'weight-700'}`}>Personal data</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('WarehouseValidate', 2)} alt="Role & document data" />
              <div className={`mt-1 s-14 ${activeStep === 2 && 'weight-700'}`}>Role & document data</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('Confirmation', 3)} alt="validate" />
              <div className={`mt-1 s-14 ${activeStep === 3 && 'weight-700'}`}>Data confirmation</div>
            </div>
          </div>
        </div>

        <div hidden={activeStep !== 1}>
          <Grid container justifyContent="center" className="mt-3">
            <Grid item sm={8} xs={12}>
              <div className="info-card mt-3">
                <h3>Personal data</h3>
                <Divider sx={{ my: 2 }} />
                <div className="mt-3 flex">
                  <div className="flex-1">
                    <label>First name</label>
                    <div>
                      <TextField placeholder="Type here" type="text" name="front_name" onChange={handleChangePD} value={personalData.front_name} fullWidth size="small" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <label>Last name</label>
                    <div>
                      <TextField placeholder="Type here" type="text" name="back_name" onChange={handleChangePD} value={personalData.back_name} fullWidth size="small" />
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <label>Email</label>
                  <div>
                    <TextField autoComplete="new-password" placeholder="Type here" type="email" name="email" onChange={handleChangePD} value={personalData.email} fullWidth size="small" inputMode="email" />
                  </div>
                </div>

                <div className="mt-3">
                  <label>Password</label>
                  <div>
                    <TextField disabled={!!courierId} autoComplete="new-password" placeholder="Type here" type="password" name="password" onChange={handleChangePD} value={personalData.password} fullWidth size="small" />
                  </div>
                </div>

                <div className="mt-3">
                  <label>Phone number</label>
                  <div>
                    <TextField placeholder="Type here" name="phone_number" onChange={handleChangePD} value={personalData.phone_number} fullWidth size="small" inputMode="numeric" />
                  </div>
                </div>

                <div className="mt-3">
                  <label>Gender</label>
                  <div>
                    <TextField
                      id="gender"
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                      label={!personalData.gender ? label.gender : null}
                      select
                      fullWidth
                      size="small"
                      name="gender"
                      onChange={handleChangePD}
                      value={personalData.gender}
                    >
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                      <MenuItem value="-">Prefer not to say</MenuItem>
                    </TextField>
                  </div>
                </div>

                <div className="mt-3">
                  <label>Marital status</label>
                  <div>
                    <TextField
                      id="marital"
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                      label={!personalData.marital_status ? label.marital : null}
                      select
                      fullWidth
                      size="small"
                      name="marital_status"
                      onChange={handleChangePD}
                      value={personalData.marital_status}
                    >
                      <MenuItem value="single">Single</MenuItem>
                      <MenuItem value="married">Married</MenuItem>
                      <MenuItem value="divorced">Divorced</MenuItem>
                      <MenuItem value="-">Prefer not to say</MenuItem>
                    </TextField>
                  </div>
                </div>

                <div className="mt-3">
                  <label>Address</label>
                  <div>
                    <TextField placeholder="Add address" type="text" multiline fullWidth size="small" name="address" onChange={handleChangePD} value={personalData.address} />
                  </div>
                  <div className="mt-3 flex">
                    <div className="flex-1">
                      <label>Country</label>
                      <div>
                        {/* <TextField placeholder="Type here" type="text"
                        fullWidth size="small" name="country" onChange={handleChangePD}
                        value={personalData.country} /> */}
                        <Autocomplete
                          options={countries}
                          value={selectedCountry}
                          loading={loadCountries}
                          onChange={(e, newVal) => {
                            setSelectedCountry(newVal);
                            setStates(newVal.states);
                            handleChangePD({ target: { name: 'country', value: newVal.name } });
                          }}
                          inputValue={personalData.country}
                          onInputChange={(e) => {
                            if (e) {
                              handleChangePD(e);
                            }
                          }}
                          getOptionLabel={(selected) => selected.name}
                          getOptionSelected={(option, value) => option.iso3 === value.iso3}
                          renderOption={(optProp, opt) => (
                            <Box key={opt.iso3} component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...optProp}>
                              <img
                                loading="lazy"
                                width="20"
                                src={`https://flagcdn.com/w20/${opt?.iso2?.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${opt?.iso2?.toLowerCase()}.png 2x`}
                                alt=""
                              />
                              {opt.name}
                              {' '}
                              (
                              {opt.iso3}
                              )
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Choose country"
                              size="small"
                              name="country"
                              InputProps={{
                                ...params.InputProps,
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex-1">
                      <label>State/Provience</label>
                      <div>
                        {/* <TextField placeholder="Type here"
                        type="text" fullWidth size="small" name="state"
                        onChange={handleChangePD} value={personalData.state} /> */}
                        <Autocomplete
                          options={states}
                          value={selectedState}
                          loading={loadCountries}
                          onChange={(e, newVal) => {
                            setSelectedState(newVal);
                            handleChangePD({ target: { name: 'state', value: newVal.name } });
                          }}
                          inputValue={personalData.state}
                          onInputChange={(e) => {
                            if (e) {
                              handleChangePD(e);
                            }
                          }}
                          getOptionLabel={(selected) => selected.name}
                          // eslint-disable-next-line max-len
                          getOptionSelected={(option, value) => option.state_code === value.state_code}
                          renderOption={(optProp, opt) => (
                            <Box key={opt.state_code} {...optProp}>
                              {opt.name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              name="state"
                              placeholder="Choose state/province"
                              InputProps={{
                                ...params.InputProps,
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 flex">
                    <div className="flex-1">
                      <label>City/Distric/Town</label>
                      <div>
                        {/* <TextField placeholder="Type here" type="text"
                        fullWidth size="small" name="city" onChange={handleChangePD}
                        value={personalData.city} /> */}
                        <Autocomplete
                          options={cities}
                          value={selectedCity || ''}
                          loading={loadCities}
                          onChange={(e, newVal) => {
                            setSelectedCity(newVal);
                            handleChangePD({ target: { name: 'city', value: newVal } });
                          }}
                          inputValue={personalData.city || ''}
                          onInputChange={(e) => {
                            if (e) {
                              handleChangePD(e);
                            }
                          }}
                          renderOption={(optProp, opt) => (
                            <Box key={opt} {...optProp}>
                              {opt}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              placeholder="Choose city"
                              name="city"
                              InputProps={{
                                ...params.InputProps,
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex-1">
                      <label>ZIP/Postal code</label>
                      <div>
                        <TextField placeholder="Type here" type="text" fullWidth size="small" name="postal_code" onChange={handleChangePD} value={personalData.postal_code} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <label>Photo 1:1</label>
                  <div>
                    <input type="file" name="photo" hidden ref={photoRef} onChange={handleChangePhoto} />
                    {files.photo
                      ? (
                        <img
                          onClick={() => photoTrigger(photoRef)}
                          width="120"
                          height="120"
                          alt="profile"
                          src={files.photo}
                          className="rounded link"
                        />
                      ) : (
                        <div className="upload-sect" onClick={() => photoTrigger(photoRef)}>
                          Photo
                        </div>
                      )}
                  </div>
                </div>
              </div>

            </Grid>
          </Grid>

          <div className="flex justify-end mt-4">
            <Button sx={{ px: 8 }} variant="outlined" className="action btn-outlined" onClick={() => setCancel(true)}>Cancel</Button>
            <Button variant="contained" className="action btn-contained" sx={{ px: 8 }} onClick={wantToContinue}>Next</Button>
          </div>
        </div>

        <div hidden={activeStep !== 2}>
          <Grid container justifyContent="center" className="mt-3">
            <Grid item sm={8} xs={12}>
              <div className="info-card mt-3">
                <h3>Document data</h3>
                <Divider sx={{ my: 2 }} />
                <div className="mt-3">
                  <label>ID number</label>
                  <div>
                    <TextField type="text" fullWidth size="small" name="id_number" onChange={handleChangeDD} value={documentData.id_number} />
                  </div>
                </div>

                <div className="mt-3">
                  <label>ID document</label>
                  <div>
                    <input type="file" hidden ref={idRef} name="id_document" onChange={handleChangePhoto} />
                    {files.id_document
                      ? (
                        <img
                          onClick={() => photoTrigger(idRef)}
                          width="180"
                          height="120"
                          alt="profile"
                          src={files.id_document}
                          className="rounded link"
                        />
                      ) : (
                        <div className="upload-sect large" onClick={() => photoTrigger(idRef)}>
                          Photo
                        </div>
                      )}
                  </div>
                </div>

                <div className="mt-3">
                  <label>Driver license Number</label>
                  <div>
                    <TextField type="text" fullWidth size="small" name="driver_license_number" onChange={handleChangeDD} value={documentData.driver_license_number} />
                  </div>
                </div>

                <div className="mt-3">
                  <label>Driver license document</label>
                  <div>
                    <input type="file" hidden ref={licenseRef} name="driver_license_document" onChange={handleChangePhoto} />
                    {files.driver_license_document
                      ? (
                        <img
                          onClick={() => photoTrigger(licenseRef)}
                          width="180"
                          height="120"
                          alt="profile"
                          src={files.driver_license_document}
                          className="rounded link"
                        />
                      ) : (
                        <div className="upload-sect large" onClick={() => photoTrigger(licenseRef)}>
                          Photo
                        </div>
                      )}
                  </div>
                </div>
              </div>

            </Grid>
          </Grid>
          <div className="flex justify-end gap-16 mt-4">
            <Button sx={{ px: 8 }} variant="outlined" className="action btn-outlined" onClick={() => setCancel(true)}>Cancel</Button>
            <Button sx={{ px: 8 }} variant="outlined" className="action btn-outlined" onClick={() => setActiveStep(1)}>Back</Button>
            <Button sx={{ px: 8 }} variant="contained" className="action btn-contained" onClick={wantToContinue}>Next</Button>
          </div>
        </div>

        <div hidden={activeStep !== 3}>
          <Grid container justifyContent="center" className="mt-3">
            <Grid item sm={8} xs={12}>
              <div className="info-card mt-3">
                <h3>Personal data</h3>
                <Divider sx={{ my: 2 }} />

                <div className="flex gap-24">
                  <img
                    width="120"
                    height="120"
                    alt="profile"
                    src={files.photo}
                    className="rounded"
                  />

                  <div className="flex-1">
                    <div className="flex space-between">
                      <div className="flex-1">
                        <div className="s-12 mute">First name</div>
                        <div className="weight-700 mt-1">{personalData.first_name}</div>
                      </div>
                      <div className="flex-1">
                        <div className="s-12 mute">Last name</div>
                        <div className="weight-700 mt-1">{personalData.last_name}</div>
                      </div>
                    </div>

                    <div className="flex space-between mt-3">
                      <div className="flex-1">
                        <div className="s-12 mute">Email</div>
                        <div className="weight-700 mt-1">{personalData.email}</div>
                      </div>
                      <div className="flex-1">
                        <div className="s-12 mute">Phone number</div>
                        <div className="weight-700 mt-1">{personalData.phone_number}</div>
                      </div>
                    </div>

                    <div className="flex space-between mt-3">
                      <div className="flex-1">
                        <div className="s-12 mute">Gender</div>
                        <div className="weight-700 mt-1">{personalData.gender}</div>
                      </div>
                      <div className="flex-1">
                        <div className="s-12 mute">Marital status</div>
                        <div className="weight-700 mt-1">{personalData.marital_status}</div>
                      </div>
                    </div>
                    <div className="mt-3">
                      <div className="s-12 mute">Address</div>
                      <div className="weight-700 mt-1">
                        {`${personalData.address}, 
                          ${personalData.city}, 
                          ${personalData.state}, 
                          ${personalData.country}, ${personalData.postal_code}`}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div className="info-card mt-5">
                <h3>Document data</h3>
                <Divider sx={{ my: 2 }} />

                <div className="flex gap-24">
                  <img
                    width="180"
                    height="120"
                    alt="document"
                    src={files.id_document}
                    className="rounded"
                  />
                  <div>
                    <div className="s-12 mute">ID Number</div>
                    <div className="weight-700 mt-1">{documentData.id_number}</div>
                  </div>
                </div>

                <div className="flex gap-24 mt-3">
                  <img
                    width="180"
                    height="120"
                    alt="document"
                    src={files.driver_license_document}
                    className="rounded"
                  />
                  <div>
                    <div className="s-12 mute">Driver license Number</div>
                    <div className="weight-700 mt-1">{documentData.driver_license_number}</div>
                  </div>
                </div>
              </div>

            </Grid>
          </Grid>
          <div className="flex justify-end gap-16 mt-4">
            <Button sx={{ px: 8 }} variant="outlined" className="action btn-outlined" onClick={() => setCancel(true)}>Cancel</Button>
            <Button sx={{ px: 8 }} variant="outlined" className="action btn-outlined" onClick={() => setActiveStep(2)}>Back</Button>
            <Button sx={{ px: 8 }} variant="contained" className="action btn-contained" onClick={() => setConfirm(true)}>Next</Button>
          </div>
        </div>

      </div>

      <Elements.ConfirmationModal
        open={confirm && activeStep === 3}
        desc={(
          <div>
            Before you add and save new courier data,
            <br />
            make sure all information is correct
          </div>
        )}
        isLoading={isLoading}
        handleClose={() => setConfirm(false)}
        handleAgree={saveCourier}
      />
      <Elements.ConfirmationModal
        open={cancel}
        desc={(
          <div>
            Are you sure want to cancel this progress?
            <br />
            your progress will not be saved
          </div>
        )}
        handleClose={() => setCancel(false)}
        handleAgree={() => navigate(-1)}
      />
    </Elements.AdminPageBase>
  );
}
